// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"fe1760cd","900":"19cff929"}[chunkId] + ".chunk.css";
};